import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import colorCategoriesService from "../../../services/color-categories.service";

const initialValues = {
  name: "",
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  color: yupSchema.optionalColorHex,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "نام دسته بندی",
    autoFocus: true,
  }
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await colorCategoriesService.editColorCategory(data.id, model);
    } else {
      op = await colorCategoriesService.createColorCategory(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "دسته بندی رنگ",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
}
